// extracted by mini-css-extract-plugin
module.exports = {"roles_segment":"EditRoles_roles_segment__8mnmm","plus_icon":"EditRoles_plus_icon__2CXPq","role_list_of_items":"EditRoles_role_list_of_items__2j4xf"};